import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NgxPermissionsService, NgxRolesService } from 'ngx-permissions';
import { Subscription } from 'rxjs';


//import constants
import { AppSettings } from '../../../../constants/app-settings';
import { AppFrontRoutes } from '../../../../constants/app-front-routes';

//import services
import { EmployeeService } from '../../../../services/employee.service';
import { ConfirmationDialogService } from 'src/app/components/general/modals/confirmation/confirmation.service';
import { GeneralService } from 'src/app/services/general.service';
import {HttpClient, HttpParams, HttpRequest, HttpEvent, HttpEventType, HttpResponse} from '@angular/common/http';
import {Observable} from "rxjs";
import { FormBuilder, FormGroup } from '@angular/forms';
declare var $: any;

@Component({
  selector: 'app-skills-course-view',
  templateUrl: './skills-course-view.component.html',
  styleUrls: ['./skills-course-view.component.css']
})



export class SkillsCourseViewComponent implements OnInit {
  createForm: FormGroup;
  createFormSubmitted: Boolean = false;
  createFormErrorMsg: any;  
  dropdownList = [];
  dropdownSettings = {};
  datatableOptions2: any;
  data: any;
  lang: any;
  deleteOption: any;
  datatableColsDefs2: any;
  datatableCols2: any;
  id:string;
  readonly AppSettings = AppSettings;
  readonly AppFrontRoutes = AppFrontRoutes;
  records: any;
  rolepermission: any;
  courseType:any;
  addPeople= [];
  constructor(
    private employeeService: EmployeeService,
    private route: ActivatedRoute,
    private ngxRolesService: NgxRolesService,
    private confirmationDialogService: ConfirmationDialogService,
    private generalService: GeneralService,
    private http: HttpClient,
    private formBuilder: FormBuilder,
  ) { }


  ngOnInit() {

 

    this.courseType = 
      {
        '1': 'Internal Course' ,
        '2': 'External Course' ,
        '3': 'Training' 
      };    

    this.dropdownSettings = {
      singleSelection: false,
      idField: 'item_id',
      textField: 'item_text',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      enableCheckAll: true,
      itemsShowLimit: 3,
      allowSearchFilter: true
    };
          
    this.id = this.route.snapshot.paramMap.get('id');

    //fetch data
    this.data = this.route.snapshot.data['sdata'];
    var role = this.ngxRolesService.getRole('servicing');

    this.rolepermission = '';
    if (role) {
      this.rolepermission = role.validationFunction[0];
    }

    this.createForm = this.formBuilder.group({
      'file_multi':[],
      'cid':this.id,
      'empid':[]
    });

    this.getData();
    this.datatableConfig1();

  }

  onSubmit(){
    this.employeeService.uploadFile(this.createForm.value)
    .subscribe(
      (res) => {
        this.getData();
      });       
  }

  datatableColumns1(): void {
    this.datatableColsDefs2 = [
      {
        targets: 0,
        visible: false,
        orderable: false,
      },
      {
        targets: 1,
        orderable: false,
        className: 'select-checkbox'
      },
    ];

    this.datatableCols2 = [
      { id: 2, value: 'No', isSelected: false },
      { id: 3, value: 'Skill Code', isSelected: false },
      { id: 4, value: 'Description', isSelected: false },
      { id: 5, value: 'Repetition', isSelected: false },
      { id: 6, value: 'Notification', isSelected: false },
      { id: 7, value: 'Level Of Competence Required', isSelected: false },
      { id: 8, value: 'Employee To Which Skill Applies', isSelected: false },
    ];

  }  

  datatableConfig1(): void {

    this.datatableColumns1();

    this.datatableOptions2 = {
      paging: false,
      bAutoWidth: false,
      bSortClasses: false,
      columnDefs: this.datatableColsDefs2,
      select: {
        style: 'multi',
        selector: 'td:first-child'
      },
      headerCallback: function (thead, data, start, end, display) {

        $('th:first-child input', thead).unbind('click');
        $('th:first-child input', thead).bind('click', () => {

          var table2 = new $.fn.dataTable.Api('#table2');

          var count = table2.rows({ selected: true }).count();
          let selected = true;

          if (count > 0) {
            table2.rows().deselect();
            selected = false;
          }
          else
            table2.rows().select();

          $('th:first-child input', thead).prop("checked", selected);

        });
      },
      initComplete: () => {

        var self = this;
        var table2 = new $.fn.dataTable.Api('#table2');

        table2
          .on('select deselect', function (e, dt, type, indexes) {

            var table2 = new $.fn.dataTable.Api('#table2');
            var selected = table2.rows({ selected: true }).indexes().toArray();

            if (selected.length === 0)
              self.deleteOption = false;
            else
              self.deleteOption = true;
          });

        var buttons2 = new $.fn.dataTable.Buttons(table2, {
          dom: {
            button: {
              className: ''
            }
          },
          buttons: [
            {
              extend: 'csv',
              text: this.lang.exportCsv,
              className: 'btn btn-info',
              exportOptions: {
                columns: '.selected',
                rows: function (idx, data, node) {
                  var dt = new $.fn.dataTable.Api('#table2');
                  var selected = dt.rows({ selected: true }).indexes().toArray();
                  if (selected.length === 0 || $.inArray(idx, selected) !== -1)
                    return true;

                  return false;
                }
              },
              title: "KaizenCloud"
            },
            {
              extend: 'pdfHtml5',
              text: this.lang.exportPdf,
              className: 'btn btn-info',
              orientation: 'landscape',
              pageSize: 'A3',
              exportOptions: {
                columns: '.selected',
                rows: function (idx, data, node) {
                  var dt = new $.fn.dataTable.Api('#table2');
                  var selected = dt.rows({ selected: true }).indexes().toArray();

                  if (selected.length === 0 || $.inArray(idx, selected) !== -1)
                    return true;


                  return false;
                }
              },
              title: "KaizenCloud"
            },
            {
              extend: 'excel',
              text: this.lang.exportExcel,
              className: 'btn btn-info',
              exportOptions: {
                columns: '.selected',
                rows: function (idx, data, node) {
                  var dt = new $.fn.dataTable.Api('#table2');
                  var selected = dt.rows({ selected: true }).indexes().toArray();

                  if (selected.length === 0 || $.inArray(idx, selected) !== -1)
                    return true;

                  return false;
                }
              },
              title: "KaizenCloud"
            },
            {
              extend: 'print',
              text: this.lang.exportPrint,
              className: 'btn btn-info',
              exportOptions: {
                columns: '.selected',
                rows: function (idx, data, node) {
                  var dt = new $.fn.dataTable.Api('#table2');
                  var selected = dt.rows({ selected: true }).indexes().toArray();

                  if (selected.length === 0 || $.inArray(idx, selected) !== -1)
                    return true;

                  return false;
                }
              },
              title: "KaizenCloud"
            },
          ], select: true
        }).container().appendTo($('#datatableExportBtn2'));

      }
    }
  }

  update_option(id,value){
    let params = {
      "id":id,
      "nae":value
    }
    this.employeeService.updateOption(params)
    .subscribe(
      (res) => {
        this.getData();
      });    
  }

  public selectAttachment(event: any,emp) {
    this.createForm.patchValue({
      'empid':emp.employeeId,
      'cid':this.id
    });
    if (event.target.files.length > 0) {
      const file = event.target.files[0];

      let reader = new FileReader();
      reader.readAsDataURL(file);

      reader.onload = () => {
        this.createForm.value.file_multi = { 'name': file.name, 'image': reader.result };
        this.onSubmit();
      };
    }

  }

  remove_certi(empid){
    let params = {
      'eid':empid,
      'cid':this.id
    }
    this.employeeService.deleteCertificate(params)
    .subscribe(
      (res) => {
        if (res.status){
          this.generalService.notify_msg('success', "Data deleted successfully");
          this.getData();
        }
        else
        this.generalService.notify_msg('error', "Unable to delete");
      });    
  }



  removeAttendees(data){
    this.confirmationDialogService.confirm('Remove participant from list', 'Do you want to delete this?')
      .subscribe(
        (confirmed) => {

          if (!confirmed)
            return;
          let params = {
            id:"2",
            cid:this.data.course.id,
            eid:data.employeeId
          }
          this.employeeService.deleteEmployee(params)
            .subscribe(
              (res) => {
                if (res.status){
                  this.generalService.notify_msg('success', "Data deleted successfully");
                  this.getData();
                }
                else
                this.generalService.notify_msg('error', "Unable to delete");
              });
        });
  }

  addAttendees(){
    let empIds = [];
    for(let data of this.addPeople){
      empIds.push(data["item_id"])
    }
    let params = {
      "course_id":this.id,
      "langOpt2": empIds
    }
    this.employeeService.addParticipants(params)
    .subscribe(
      (res) => { 
        this.getData();
        this.addPeople = [];

    })
    
  }

 
  getData() {

    this.employeeService.getCourseDetails(this.id)
      .subscribe(
        (res) => {
          this.lang = this.employeeService.listLang(res);
          this.data = res.data;

          for(let emp of this.data.act_emplys){
            var temp =  {
              item_id:emp["employeeId"],
              item_text: emp["employee_name"]+" "+emp["employee_surname"]
            }
            this.dropdownList = this.dropdownList.concat(temp);
          }

        }
      );
  }

}
